import React from "react";
import "../styles/SacMtbGame.css";

function SacMtbGame() {
  return (
    <div className="game-coming-soon">
      <h1>SAC MTB Game</h1>
      <p>🚴‍♂️ Coming Soon... Stay Tuned!</p>
    </div>
  );
}

export default SacMtbGame;
